import { signIn } from 'aws-amplify/auth';
import { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '~/utils';

export const Login = () => {
    const { id } = useParams();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');

    const username = id || '';

    if (user) return <Navigate to="/" replace />;

    const handleSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        try {
            const { isSignedIn, nextStep } = await signIn({ username, password });
            if (isSignedIn && nextStep?.signInStep === 'DONE') {
                console.log('✅ Login successful!');
                navigate('/');
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div>
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Login</button>
            </form>
        </div>
    );
};
